import { ZonePlacement } from '@/models/zoneplacement';
import { Store } from '@/models/storetarget';
import { Promotion } from '@/models/promotion';

type StoreWithState = Store & {
  state: string;
};

export function getUniqueStates(stores: Store[] | undefined) {
  if (!stores) return [];

  const validStates = stores
    .filter((store): store is StoreWithState => Boolean(store.state))
    .map((s) => s.state);

  return Array.from(new Set(validStates)).sort();
}

export function getZonePlacements(
  targeting: Promotion['targeting'],
  zonePlacements: ZonePlacement[],
) {
  // Create a map of all placements to their parent zones
  const placementToZoneMap = new Map(
    zonePlacements
      .flatMap((zone) =>
        (zone?.placements ?? []).map(
          (placement) => [placement.id, zone] as const,
        ),
      )
      .filter((entry) => entry !== undefined),
  );

  // Get zones directly targeted by zone_ids
  const zoneIds = targeting.zones.map((z) => z.id);
  const directZones = zonePlacements
    .filter((zone) => zoneIds.includes(zone.id))
    .map((zone) => ({
      id: zone.id,
      name: zone.name,
    }));

  // Get zones that contain the targeted placements
  const placementIds = targeting.placements.map((p) => p.id);
  const placementZones =
    placementIds
      ?.map((id) => placementToZoneMap.get(id))
      .filter((zone) => zone !== undefined)
      .map((zone) => ({
        id: zone?.id,
        name: zone?.name,
      })) ?? [];

  // Combine and deduplicate zones
  const uniqueZones = Array.from(
    new Map(
      [...directZones, ...placementZones].map((zone) => [zone.id, zone]),
    ).values(),
  );

  return uniqueZones;
}
